import { defineStore } from 'pinia'
import {
  httpAuthLogin,
  httpAuthRequestChkVal,
  httpAuthCheckChkVal,
  httpAuthPrepareChkVal
} from '@/service/apis/comm/auth/auth.api'
import { HttpMenuAuthRetrieveUserInfo } from '@/service/apis/comm/cm/sy/authmng.api'
import { httpSuppMoCmAuthmngUserCheckPasswdExpr } from '@/service/apis/supp/mo/cm.api'
import { httpCmSySyscnfFecnfRetrieveFeBuildVer } from '@/service/apis/comm/cm/sy/syscnf.api'
import { httpHelper } from '@/utils/helper/http.helper'
import { gfnSysDate } from '@/utils/helper/date.helper'
import { cloneDeep } from 'lodash-es'
import { httpCmSyCmmMsgRetrieveAllMsgList, httpCmSyCmmCalenRetrieveHoliday } from '@/service/apis/comm/cm/sy/cmm.api'
import { stopPositTrnsSvc } from '@/utils/positTrns'
import { dayjs } from '@gsretail/gssm-util'

const X_SESSION_INITIAL = {
  'X-GSSM-SYS-SP-CD': 'ST'
}

export const useCMSYAUTHstore = defineStore({
  id: 'useCMSYAUTHstore',

  state: () => ({
    authInfo: {
      accessToken: '',
      refreshToken: '',
      secondAuthYn: ''
    },
    persistedAuthInfo: {
      accessToken: '',
      refreshToken: '',
      secondAuthYn: ''
    },
    persistedLoginInfo: {
      id: '',
      passwd: ''
    },
    user: {
      userId: '', // 사용자ID
      userNm: '', // 사용자명
      carNo: '', // 차량번호
      suppNm: '', // 배달협력사명
      strNm: '', // 점포명
      joinCd: '' // 가입코드
    },
    xSession: cloneDeep(X_SESSION_INITIAL),
    menuList: [],
    msgList: [],
    curChannel: '',
    isAutoLogin: false,
    cachedSysDate: ''
  }),

  getters: {
    getUser: (state) => state.user,
    getXsession: (state) => {
      return state.xSession
    },
    getChannels: (state) => {
      return state.menuList.filter((menu) => menu.lvl === '0').map((menu) => menu.lvl0Nm)
    },
    getCurMenu: (state) => {
      const currentRoute = state.router.currentRoute.value
      const currentMenu = state.menuList.find((menu) => menu.scrId === currentRoute.name)
      return currentMenu
    },
    getCurMenuAuth() {
      const menu = this.getCurMenu
      return {
        edit: menu?.modAuthYn === 'Y',
        print: menu?.prntAuthYn === 'Y'
      }
    },
    getIsLoggedIn: (state) => state.authInfo.accessToken !== '' && state.authInfo.secondAuthYn === 'N',
    getMsgByMsgCd: (state) => (msgCd_) => {
      return state.msgList.find((item) => item.msgCd === msgCd_) || undefined
    },
    getNativeApplVer: () => {
      const isMobile = $nvBridge.isReady
      const ver = isMobile ? $nvBridge.deviceInfoData.appVersion : 'WEB'
      return ver == null || ver === '' ? '-' : ver
    }
  },

  actions: {
    async actionHttpAuthLogin(fdata) {
      try {
        const response = await httpHelper(httpAuthLogin, fdata)
        console.debug('httpAuthLogin response :', response)
        return response
      } catch (error) {
        console.debug('httpAuthLogin error :', error)
      }
    },
    async actionHttpUserInfo() {
      try {
        const { data } = await httpHelper(HttpMenuAuthRetrieveUserInfo)
        console.debug('actionHttpUserInfo data :', data)
        data.whCd = '1200'
        data.whNm = '서울센터'
        this.actionSettUser(data)
        return data
      } catch (error) {
        console.debug('actionHttpUserInfo error :', error)
      }
    },
    async actionHttpAuthRequestChkVal() {
      try {
        const data = await httpHelper(httpAuthRequestChkVal)
        return data
      } catch (error) {}
    },
    async actionHttpAuthCheckChkVal(fdata) {
      try {
        const res = await httpHelper(httpAuthCheckChkVal, fdata)
        return res
      } catch (error) {}
    },
    async actionHttpAuthPrepareChkVal(fdata) {
      try {
        const res = await httpHelper(httpAuthPrepareChkVal, fdata)
        return res
      } catch (error) {}
    },
    async actionSetXsession(data_) {
      console.debug('actionSetXsession data_:', data_)
      this.xSession = data_
    },
    async actionGetCurrentDt() {
      const returnValue = await gfnSysDate()
      return returnValue
    },
    async actionSettUser(data_) {
      this.user = data_
    },
    async actionSetMenuList(data_) {
      this.menuList = data_
    },
    async actionLogout() {
      stopPositTrnsSvc()
      this.authInfo.accessToken = ''
      this.authInfo.refreshToken = ''
      this.authInfo.secondAuthYn = ''
      this.persistedAuthInfo = cloneDeep(this.authInfo)
      this.xSession = cloneDeep(X_SESSION_INITIAL)
    },
    async actionSaveLogin(loginInfo) {
      this.persistedLoginInfo = cloneDeep(loginInfo)
    },
    actionSaveAuth() {
      this.authInfo.secondAuthYn = 'N'
      this.persistedAuthInfo = cloneDeep(this.authInfo)
    },
    actionLoadAuth() {
      this.authInfo = cloneDeep(this.persistedAuthInfo)
    },
    async actionHttpCheckBuildVer(fdata) {
      try {
        const { data } = await httpHelper(httpCmSySyscnfFecnfRetrieveFeBuildVer, fdata)
        console.debug('actionHttpCheckBuildVer data :', data)
        return data
      } catch (error) {
        console.debug('actionHttpCheckBuildVer error :', error)
        throw error
      }
    },
    async actionHttpCheckPasswdExpr() {
      try {
        const res = await httpHelper(httpSuppMoCmAuthmngUserCheckPasswdExpr)
        return res
      } catch (error) {
        console.debug(error)
        throw error
      }
    },
    async actionHttpAllMsgList() {
      try {
        const { data } = await httpHelper(httpCmSyCmmMsgRetrieveAllMsgList)
        this.msgList = data
        return data
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async actionHttpHoliday() {
      const curYear = Number(await gfnSysDate('YYYY'))
      const fdata = {
        fromYear: String(curYear - 3),
        toYear: String(curYear + 1)
      }

      try {
        const { data } = await httpHelper(httpCmSyCmmCalenRetrieveHoliday, fdata)

        this.holidayList = data.map((item) => ({
          ...item,
          holidayDt: dayjs(item.holidayDt).format('YYYY.MM.DD')
        }))
        localStorage.setItem('GSSM_HOLIDAYLIST', JSON.stringify(this.holidayList))
      } catch (error) {
        console.debug('actionHttpHoliday error :', error)
      }
    }
  },
  persistedState: {
    includePaths: ['persistedAuthInfo', 'persistedLoginInfo', 'xSession'],
    overwrite: true,
    key: `GSSM_MOBILE_DLVR_useCMSYAUTHstore`
  }
})
